<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other"></i>
        {{ $route.query.id ? "巡查人员编辑" : "新增巡查人员" }}
      </div>
    </div>
    <el-form ref="form" :model="form" label-width="110px" :rules="rule">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="登录账号" prop="userName">
            <el-input v-model="form.userName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <!--                <el-col :span="6">-->
        <!--                    <el-form-item label="登录密码" prop="login_pass">-->
        <!--                        <el-input v-model="form.login_pass" placeholder="请输入" ></el-input>-->
        <!--                    </el-form-item>-->
        <!--                </el-col>-->
        <el-col :span="6">
          <el-form-item label="真实姓名" prop="nickName">
            <el-input v-model="form.nickName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>

        <!-- <el-col :span="6">
                    <el-form-item label="" prop="role_key">
                        <el-select v-model="form.role_key" placeholder="请选择">
                            <el-option v-for="item in roles" :label="item.role_value" :value="item.role_key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col> -->
        <el-col :span="6">
          <el-form-item label="手机号" prop="phoneNumber">
            <el-input
              v-model="form.phoneNumber"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
                    <el-form-item label="电子邮箱" prop="user_email">
                        <el-input v-model="form.user_email" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col> -->
        <el-col :span="6">
          <el-form-item label="修改密码" prop="pwd">
            <el-input
              type="password"
              v-model="form.pwd"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
                    <el-form-item label="巡查区域" prop="xc_point" >
                        <el-select v-model="form.xc_point" multiple="multiple">
                                <el-option v-for="item in pointList" :label="item.areaName" :value="item.areaId"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                 <el-col :span="6">
                    <el-form-item label="标签类型" prop="xc_nfcArray">
                        <el-select v-model="form.xc_nfcArray" multiple='multiple'>
                        <el-option v-for="item in typeList" :label="item.name" :value="item.id" ></el-option>
                        </el-select>
            
                    </el-form-item>
                </el-col>  -->
        <el-col :span="6">
          <el-form-item label="GPS范围" prop="inspectionScope">
            <!-- <el-input type="password" v-model="form.login_pass" placeholder="请输入" ></el-input> -->
            <el-select v-model="form.inspectionScope">
              <el-option
                v-for="item in ['20', '50', '100', '200', '500']"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!-- <el-col :span="6">
                    <el-form-item label="所属单位" prop="company_num">
                        <el-select v-model="form.company_num" placeholder="请选择">
                            <el-option v-for="item in units" :key="item.c_company_num" :label="item.c_name" :value="item.c_company_num"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col> -->
      </el-row>
      <!-- 穿梭框 -->
      <el-row justify="center" align="middle" type="flex">
        <el-transfer
          :titles="['全部单位', '已选单位']"
          v-model="value"
          :data="data"
        ></el-transfer>
      </el-row>

      <div class="btn-box center">
        <el-button type="primary" @click="onSubmit">保存</el-button>

        <el-button type="primary" class="ml20" @click="$router.back()"
          >返回</el-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
import { addUser } from "../../api/user";
export default {
  data() {
    return {
      form: {
        user_name: "",
        nick_name: "",
        phonenumber: "",
        login_pass: "",
        xc_nfcArray: [],
        inspectionType: this.$route.query.inspection || "",
        xc_point: [],
        xc_area: "",
      },
      pointList: [],
      roles: [],
      rule: {
        company_num: {
          required: true,
          message: "请选择所属单位",
          trigger: "change",
        },
        role_key: {
          required: true,
          message: "请选择分配角色",
          trigger: "change",
        },
      },
      units: [],
      typeList: [
        { name: "二维码", id: "1" },
        { name: "NFC", id: "2" },
        { name: "GPS", id: "3" },
      ],
      data: this.generateData(),
      value: [],
    };
  },
  created() {
    this.form.inspectionType = this.$route.query.inspection;
    this.$get("/user/roleandcompany").then((res) => {
      this.roles = res.data.role;
      this.units = res.data.company;
    });
    let c_num = this.$store.state.user.company.cCompanyNum || "";

    this.$get(
      "/relic/relicInspectionCompanyArea/listNotPage?companyNum=" + c_num
    ).then((res) => {
      this.pointList = res.data;
    });
    // var url = this.form.inspectionType==1 ? 'xuncha/xunchaareadetail' : '/xuncha/xunchaareadetailWenWu'
    // this.$post(url,{c_company_num:this.$store.state.user.company.cCompanyNum}).then(res=>{
    //     this.pointList = res.data
    // })
    if (this.$route.query.id) {
      this.$get("/relic/inspectionUser/" + this.$route.query.id).then((res) => {
        console.log(res, 333333);

        this.form = res.data;
        if (this.form.regulatoryUnit) {
            this.value=this.form.regulatoryUnit.split(',')
        }
        if (this.form.inspectionScope == "null") {
          this.form.inspectionScope = "";
        }

        this.$set(
          this.form,
          "xc_point",
          this.form.xc_area ? this.form.xc_area.split(",") : []
        );

        this.$set(
          this.form,
          "xc_nfcArray",
          this.form.xc_nfc ? this.form.xc_nfc.split(",") : []
        );
      });
    }
  },
  methods: {
    generateData() {
      const data = [];
      let flag = [];
      this.$get("/devicemanage/selectconpanybyme").then((res) => {
        console.log(res);
        res.data.forEach((item, index) => {
          data.push({
            key: item.c_company_num,
            label: item.c_name,
          });
        });
      });
      return data;
    },
    changeFile(file, fileList) {
      log(file, fileList);
    },
    onSubmit() {
      this.form.xc_area = this.form.xc_point.join(",");
      this.form.xc_nfc = this.form.xc_nfcArray.join(",");
        if (this.value) {
         this.form.regulatoryUnit=this.value.join(",");
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.status = 1;
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    save() {
      //  if(!this.form.xc_point.length){
      //      this.$message.warning("请选择巡查区域")
      //      return
      //  }

      let loading = this.$loading({ background: "rgba(0, 0, 0, 0.6)" });
      // let api = this.$route.query.id ? '/user/editsaveuser' : '/patrol/addxcperson';
      this.$put("/relic/inspectionUser", this.form)
        .then((res) => {
          // this.$message.success('保存成功')
          this.$message({
            message: "保存成功",
            type: "success",
            duration: 700,
          });
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
  },
};
</script>

<style scoped></style>
